import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "@vitalsource/vstui";
import { Popover } from "@vitalsource/vstui/labs";
import { withTheme } from "styled-components";
import { t } from "../../../../../core/translate";
import { selectors as brandSelectors } from "../../../../../../redux/brand";
import { selectors as userSelectors } from "../../../../../../redux/user";
import { shouldShowReadOffline } from "../../../../../utils/read-offline";
import { downloadApp } from "../../../../../utils/read-offline";
import { Apps as AppsIcon } from "../../icons";
import {
  ThemedButton,
  ReadOffline as ReadOfflineWrapper,
  PromoteMobile as PromoteMobileButton,
  PromoteMobileDetails,
  Watkins
} from "../styles";
import IconList from "./icon-list";

const PromoteMobile = ({ watkins }) => (
  <PromoteMobileButton color="neutral" naked onClick={() => {}}>
    {watkins && <Watkins src="/img/watkins_star.svg" />}
    <PromoteMobileDetails>
      <h4>{t("mobile-apps.read-on-the-go")}</h4>
      <p>{t("mobile-apps.get-link-sms-only")}</p>
    </PromoteMobileDetails>
    {/* {<Isvg src="/img/arrow_lg.svg" />} */}
  </PromoteMobileButton>
);

const ReadOffline = ({ isBookshelfBrand }) => (
  <ReadOfflineWrapper>
    <p>
      {t("main-menu.read-offline-text", "Read Offline with our Desktop App", {
        bookshelf: isBookshelfBrand ? t("global-bar.bookshelf") : "",
        device: Fraction.Helpers.Browser.deviceCheck()
      })}
    </p>
    <Button href="#" target="_blank" onClick={downloadApp}>
      <span>{t("main-menu.download")}</span>
    </Button>
  </ReadOfflineWrapper>
);

export class Apps extends Component {
  content() {
    return (
      <div>
        <IconList />
        {shouldShowReadOffline() ? (
          this.props.promoteMobile ? (
            <PromoteMobile watkins={this.props.watkins} />
          ) : (
            <ReadOffline isBookshelfBrand={this.props.isBookshelfBrand} />
          )
        ) : null}
      </div>
    );
  }

  render() {
    if (this.props.loading) {
      return null;
    }

    return (
      <Popover content={this.content()}>
        <ThemedButton
          color="white"
          colorBehindButton={this.props.theme.vstui.color.secondary.getShade(7)}
          iconStart={<AppsIcon />}
          label={t("global-bar.app", "App")}
          tooltipPlacement="bottom"
          naked
        />
      </Popover>
    );
  }
}

const mapStateToProps = state => ({
  isBookshelfBrand: brandSelectors.isBookshelfBrand(state),
  loading: userSelectors.isUserFetching(state),
  promoteMobile: brandSelectors.getBrandValue(
    state,
    "ReadOffline.promoteMobile",
    true
  ),
  watkins: brandSelectors.getBrandValue(state, "Graphics.watkins", true)
});

export default withTheme(
  connect(
    mapStateToProps,
    null
  )(Apps)
);
